var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompleted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.042 10a8.958 8.958 0 1017.916 0 8.958 8.958 0 00-17.916 0zm12.854-3.114c.34.311.362.838.051 1.177l-4.583 5a.834.834 0 01-1.203.027l-2.084-2.084a.833.833 0 111.179-1.178l1.468 1.468 3.995-4.359a.833.833 0 011.177-.051z",
    fill: "#219653"
  })));
}
export default SvgCompleted;